import { Completion } from "common/entities/Subscription";
import Loading from "common/fragments/Loading";
import NonIdealState from "common/fragments/NonIdealState";
import HeadingView from "common/views/heading/Heading.view";
import { RowsView } from "common/views/rows/Rows.view";
import { IPanelProps, Panel } from "core/decorators/Panel";
import { IQueryRoot, QueryRoot } from "core/decorators/QueryRoot";
import React from "react";
import { addEnum, Field } from "typegraph";
import labelProvider from './LearningSummary.labels';
import LearningSummaryConfig from "./LearningSummaryConfig";
import StringUtil from "core/util/StringUtil";
import configureStore from "core/store/configureStore";
import { toFixed } from "core/util/MathUtils";


const { Labels } = labelProvider;

class ValueResult {
	@Field()
	public value: number;
}

class CountResult {
	@Field()
	public count: number;
}

const completedFilter = [addEnum(Completion.Completed), addEnum(Completion.Passed)];

function mapCreditEntryParams(globalParams: any = {}) {
	const params = {
		granted: true,
		pageSize: 2000
	}
	if (globalParams.creditTypeIds) {
		params["creditTypeIds"] = globalParams.creditTypeIds;
	}
	
	return {params};
}

function mapCreditEntryYtdParams(globalParams: any = {}) {
	const p = mapCreditEntryParams(globalParams);
	p.params["grantedOnRangeStart"] = new Date().getFullYear() + "-01-01T00:00:00-0800";
	
	return p;
}

class LearningSummaryQuery {

	@Field({
		entity: ValueResult,
		aliasFor: "creditEntriesUser",
		/*params: {
			params: {
				granted: true,
				pageSize: 2000
			}
		}*/
		params: mapCreditEntryParams
		
	})
	public totalCredits: ValueResult[];

	@Field({
		entity: ValueResult,
		aliasFor: "creditEntriesUser",
		params:mapCreditEntryYtdParams
		/*params: {
			params: {
				grantedOnRangeStart: new Date().getFullYear() + "-01-01T00:00:00-0800",
				granted: true,
				pageSize: 2000
			}
		}*/
		/*params: (globalParams: any) => ({
			params: {
				grantedOnRangeStart: new Date().getFullYear() + "-01-01T00:00:00-0800",
				granted: true,
				pageSize: 2000,
				creditTypeIds: globalParams.creditTypeIds ? globalParams.creditTypeIds : null
			}
		 })*/
	})
	public ytdCredits: ValueResult[];

	@Field({
		entity: CountResult,
		aliasFor: "subscriptionsUserCount",
		params: {
			params: {
				completions: completedFilter
			}
		}
	})
	public totalCompletions: CountResult;

	@Field({
		entity: CountResult,
		aliasFor: "subscriptionsUserCount",
		params: {
			params: {
				completedOnRangeStart: new Date().getFullYear() + "-01-01T00:00:00-0800",
				completions: completedFilter
			}
		}
	})
	public ytdCompletions: CountResult;

}

function mergeConfigAndParams(config: LearningSummaryConfig, pageParams: { [key: string]: string; }) {
	const p = {}
	p["enableRefine"]=config.enableRefine;
	if (config.creditTypeIds) {
		p["creditTypeIds"] = StringUtil.toIntegerList(config.creditTypeIds);
	}
	return p;
}

/**
 * LearningSummaryPanel displays learning summary counts
 * like ytd completions, total completions, ytd credits ,total credits
 *
 */
@Panel({ id: "learning-summary", configClass: LearningSummaryConfig, pageParams: true, labelProvider })
@QueryRoot(LearningSummaryQuery, mergeConfigAndParams)
export class LearningSummaryPanel extends React.PureComponent<IPanelProps<LearningSummaryConfig> & IQueryRoot<LearningSummaryQuery>> {

	public render() {

		const { queryData, queryState, config } = this.props;

		if (queryState.loading) {
			return (
				<div style={{ marginTop: '-20px' }}>
					<Loading />
				</div>
			);
		}

		if (!queryData) {
			return (
				<NonIdealState
					title={<Labels.SummaryEmpty />}
					description={<Labels.DescriptionEmpty />}
				/>
			);
		}

		return (
			<RowsView viewKey="rows">
				{config.enableYTDCompletion && (<div style={{textAlign: 'center'}}>
						<HeadingView viewKey="metric.count">
							{((queryData && queryData.ytdCompletions && queryData.ytdCompletions.count) || "0")}
						</HeadingView>
						<HeadingView viewKey="metric.label">
							<Labels.YTDCompletions />
						</HeadingView>
					</div>)}

					{config.enableTotalCompletion && (<div style={{textAlign: 'center'}}>
						<HeadingView viewKey="metric.count">
							{((queryData && queryData.totalCompletions && queryData.totalCompletions.count) || "0")}
						</HeadingView>
						<HeadingView viewKey="metric.label">
							<Labels.TotalCompletions />
						</HeadingView>
					</div>)}

					{config.enableYTDCredits && (<div style={{textAlign: 'center'}}>
						<HeadingView viewKey="metric.count">
							{
								function(){
									if(queryData && queryData.ytdCredits){
										const YTDCredits = queryData.ytdCredits.map((r) => r.value).reduce((a, cv) => a + cv);
										return toFixed(YTDCredits, config.fractionDigits)
									} else {
										return "0"
									}
								}()
							}
						</HeadingView>
						<HeadingView viewKey="metric.label">
							<Labels.YTDCredits />
						</HeadingView>
					</div>)}

					{config.enableTotalCredits && (<div style={{textAlign: 'center'}}>
						<HeadingView viewKey="metric.count">
							{
								function(){
									if(queryData && queryData.totalCredits){
										const totalCredits = queryData.totalCredits.map((r) => r.value).reduce((a, cv) => a + cv)
										return toFixed(totalCredits, config.fractionDigits)
									}else{
										return "0";
									}
								}()
							}
						</HeadingView>
						<HeadingView viewKey="metric.label">
							<Labels.TotalCredits />
						</HeadingView>
					</div>)}
			</RowsView>
		);
	}
}





// WEBPACK FOOTER //
// ./src/panels/learningSummary/LearningSummary.panel.tsx